module.exports = __webpack_public_path__ + "static/media/line-spacing.6570e74b.svg";